import { Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "@auth0/auth0-angular";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { Subscription, pipe, Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { TokenData } from "../shared/interfaces/token-data.interface";
import { UsuarioDTO } from "../shared/interfaces/usuario.interface";
import { NotificacionesService } from "../shared/services/rest/notificaciones.service";
import { UsuarioService } from "../shared/services/rest/usuario.service";

import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
@Component({
    selector: "app-perfil",
    templateUrl: "./perfil.component.html",
    styleUrls: ["./perfil.component.scss"],
})
export class PerfilComponent implements OnInit, OnDestroy {
    perfilUsuario: UsuarioDTO;
    tokenData: TokenData;
    subscripciones: Subscription;
    fotoPerfil: any;
    perfil$: Observable<UsuarioDTO>;
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _usuarioSrvc: UsuarioService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _authSrvc: AuthService,
        private _notificacionesSrvc: NotificacionesService //private _sanitizer: DomSanitizer
    ) {
        this.subscripciones = new Subscription();

        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    async ngOnInit() {
        this.perfil$ = this._usuarioSrvc.perfil$;

        this.subscripciones.add(
            this._authSrvc.user$.subscribe((resp) => (this.tokenData = resp))
        );
    }

    guardarNotificaciones(notificacionesActivas: number[]) {
        this._fuseProgressBarService.show();
        this._usuarioSrvc
            .guardarConfiguracionNotificaciones(notificacionesActivas)
            .pipe(finalize(() => this._fuseProgressBarService.hide()))
            .subscribe((reps) =>
                this._notificacionesSrvc.mostrarNotificacion(
                    "Notificaciones actualizadas",
                    "success"
                )
            );
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
